import { RichTextInput } from '@infotech-soe/erp-ui-kit';
import React from 'react';

import { RichTextFormControlViewModel } from '../../../services/form/view-model/FormControlViewModel';
import { useAppSelector } from '../../../store/hooks';
import { getCurrentLocaleName } from '../../../store/selectors/intl';

import { TFormControlConnectorProps } from './FormControlContainer';
import FormLabeledInputControl from './FormLabeledInputControl';
import FormTextControl from './hoc/FormTextControl';

interface Props extends Pick<TFormControlConnectorProps, 'areHintsShown'> {
  control: RichTextFormControlViewModel;
  value: string;
  onChanged: (value: string | null) => void;
}

const FormRichTextInputControl = ({
  areHintsShown,
  control,
  value,
  onChanged,
}: Props): React.JSX.Element => {
  const currentLocale = useAppSelector(getCurrentLocaleName);

  return (
    <FormLabeledInputControl areHintsShown={areHintsShown} control={control}>
      <RichTextInput
        value={value}
        locale={currentLocale}
        onChanged={onChanged}
        readOnly={control.readonly}
        invalid={control.invalid}
        required={control.required}
        disabled={control.disabled}
        rows={control.rows}
        hideMenu={control.hideMenu}
        hideToolbar={control.hideToolbar}
      />
    </FormLabeledInputControl>
  );
};

export default FormTextControl(FormRichTextInputControl);
